import { createRouter, createWebHistory } from "vue-router";
//CCOnboarding
import BasicInformation from "@/views/public/CCOnboarding/BasicInformation.vue";
import Qrcode from "@/views/public/CCOnboarding/Qrcode.vue";
import ContactVerification from "@/views/public/CCOnboarding/ContactVerification.vue";
import PersonalInformation from "@/views/public/CCOnboarding/PersonalInformation.vue";
import EmergencyContact from "@/views/public/CCOnboarding/EmergencyContact.vue";
import EmploymentDetails from "@/views/public/CCOnboarding/EmploymentDetails.vue";
import PrincipalCardDetails from "@/views/public/CCOnboarding/PrincipalCardDetails.vue";
import UploadDocuments from "@/views/public/CCOnboarding/UploadDocuments.vue";
import SupplementaryCardDetails from "@/views/public/CCOnboarding/SupplementaryCardDetails.vue";
import SendBack from "@/views/public/CCOnboarding/SendBack.vue";
import Acknowledgement from "@/views/public/CCOnboarding/Acknowledgement.vue";
import CCProgressRoutePage from "@/views/public/CCOnboarding/ProgressRoutePage.vue";
import CCOnboard from "@/views/public/CCOnboarding/Main.vue";
import ProgressRoutePageSendBack from "@/views/public/CCOnboarding/ProgressRoutePageSendBack.vue";
import Test from "@/components/test.vue";

// /cc-onboard/
const router = createRouter({
  //cc-onboard
  history: createWebHistory("/cc-onboard"),
  routes: [
    //CC Onboarding
    {
      path: "/basicInformation",
      name: "BasicInformation",
      component: BasicInformation,
    },
    {
      path: "/qrcode",
      name: "Qrcode",
      component: Qrcode,
    },
    {
      path: "/contactverification",
      name: "ContactVerification",
      component: ContactVerification,
    },
    {
      path: "/personalInformation",
      name: "PersonalInformation",
      component: PersonalInformation,
    },
    {
      path: "/emergencyContact",
      name: "EmergencyContact",
      component: EmergencyContact,
    },
    {
      path: "/employmentDetails",
      name: "EmploymentDetails",
      component: EmploymentDetails,
    },
    {
      path: "/principalCardDetails",
      name: "PrincipalCardDetails",
      component: PrincipalCardDetails,
    },
    {
      path: "/uploadDocuments",
      name: "UploadDocuments",
      component: UploadDocuments,
    },
    {
      path: "/supplementaryCardDetails",
      name: "SupplementaryCardDetails",
      component: SupplementaryCardDetails,
    },
    {
      path: "/webform/apply/sendBack/request",
      name: "ProgressRoutePageSendBack",
      component: ProgressRoutePageSendBack,
    },
    {
      path: "/webform/apply/sendBack/request",
      name: "SendBack",
      component: SendBack,
    },
    {
      path: "/acknowledgement",
      name: "Acknowledgement",
      component: Acknowledgement,
      props: (route) => ({
        status: route.query.status,
        refNo: route.query.refNo,
        type: route.query.type,
        cardName: route.query.cardName,
        date: route.query.date,
        time: route.query.time,
      }),
    },
    {
      path: "/webform/apply/request",
      name: "CCProgressRoutePage",
      component: CCProgressRoutePage,
    },
    // {
    //   path: "/webform/apply/cc",
    //   name: "CCOnboard",
    //   component: CCOnboard,
    // },
    {
      path: "/webform/apply/request",
      name: "CCOnboard",
      component: CCOnboard,
      props: (route) => ({
        cc: route.query.cc || "",
        type: route.query.type || "",
        webFormRequestId: route.query.webFormRequestId || "",
        acc: route.query.ACC || "",
        bc: route.query.BC || "",
        rci: route.query.RCI || "",
        cpc: route.query.CPC || "",
        mci: route.query.MCI || "",
        mc: route.query.MC || "",
        crfn: route.query.CRFN || "",
      }),
    },
    {
      path: "/test",
      name: "testing",
      component: Test,
    },
    {
      path: "/:pathMatch(.*)*",
      redirect: (to) => {
        return {
          name: "Acknowledgement",
          query: { status: "invalidLink" },
        };
      },
    },
  ],
});

export default router;
